/**
 * 빌드 타깃 판정 상수. `next.config.ts`가 주입하는 NEXT_PUBLIC_APP_TARGET을 빌드
 * 시점에 인라인한다. web 빌드는 항상 'web'이다(구 portal 이중 빌드는 제거됨).
 * 런타임 분기는 이 모듈 한 곳만 본다.
 */
export type AppTarget = 'web' | 'portal';

export const appTarget: AppTarget = process.env.NEXT_PUBLIC_APP_TARGET === 'portal' ? 'portal' : 'web';

export const isPortalBuild = appTarget === 'portal';
